var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l((_vm.props.row.optimisation),function(v,k,i){return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.getLabel(k)),expression:"getLabel(k)"}],key:i,domProps:{"innerHTML":_vm._s(_vm.getStatus(v.status))}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }